import { AxiosInstance, AxiosResponse } from 'axios';
import ColisportApiResource from './colisport-api-resource.model';

export default class HealthApi implements ColisportApiResource {
  readonly apiUrlPath = 'health';

  constructor(readonly httpClient: AxiosInstance) {}

  /**
   * Readiness do backend (DB, etc.)
   */
  getReadiness(): Promise<AxiosResponse> {
    return this.httpClient.get(`${this.apiUrlPath}/ready`);
  }

  /**
   * Info / environment
   */
  getEnvironment(): Promise<AxiosResponse<string>> {
    return this.httpClient.get(`${this.apiUrlPath}/environment`);
  }
}
